import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SaveDialog from "./SaveDialog";
import {useBoolState, useDomainNameQuery} from "@/hooks";
import {ProvisionedDevice} from "../../types";
import {useDataSource} from "./DataSource";
import {ContextFilters, useAuth} from "@/context/AuthProvider";
import ReadonlyDialog from "./ReadonlyDialog";
import {commonTranslations} from "@/utils/translations";

type Props = {
    device: ProvisionedDevice;
    onSuccess: () => void;
    domainId: number;
};

const UpdateOrInfoButton = ({onSuccess, device, domainId}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const dataSource = useDataSource(domainId, isOpen, {device});
    const auth = useAuth();
    const {domainName} = useDomainNameQuery(domainId);

    if (auth.hasPermission("manage_provisioned_device", ContextFilters.domain(domainName))) {
        return (
            <>
                <IconButton color="primary" size="small" onClick={open}>
                    <FontAwesomeIcon icon="pencil-alt" />
                </IconButton>
                <SaveDialog
                    isOpen={isOpen}
                    close={close}
                    title={commonTranslations.devices.provisioned.dialogTitles.update}
                    titleValues={{name: device.macAddress}}
                    dataSource={dataSource}
                    onSuccess={onSuccess}
                    cacheKeyPostfix={`update_${device.id}`}
                />
            </>
        );
    }

    return (
        <>
            <IconButton color="primary" size="small" onClick={open}>
                <FontAwesomeIcon icon="info" />
            </IconButton>
            <ReadonlyDialog
                isOpen={isOpen}
                close={close}
                title={commonTranslations.devices.provisioned.dialogTitles.view}
                titleValues={{name: device.macAddress}}
                dataSource={dataSource}
            />
        </>
    );
};

export default UpdateOrInfoButton;
